import React from "react";
import { GridLegacy } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { AxiosRequest } from "../../Url";
import { createRoot, Root } from "react-dom/client";
import { tokenProcessingTest } from "../../TokenProcessing/TokenProcessing";
import ModalContainer from "../Module/ModalContainer";
import Button from "@mui/material/Button";
import { ClearAllLoadMask } from "../Tools/Tools";

const ChangeStatusProgressFooter = (props: any) => {
  const [Progress, setProgress] = React.useState(0);
  const [data, setData] = React.useState<any>({});
  const [Title, setTitle] = React.useState("");
  const [ReqId, setReqId] = React.useState("");
  //   const [open, setOpen] = React.useState(true);
  const [stop, setStop] = React.useState(false);

  React.useEffect(() => {
    // SetLoadingCursor(true);
  }, []);

  React.useEffect(() => {
    if (data.error) {
      const Message = `Ошибка выполнения операции на сервере: ${data.error.content}`;
      const renderDefaultEl = document.getElementById("RenderDefault")!;
      const renderDefaultElRoot: Root = renderDefaultEl.root || createRoot(renderDefaultEl);
      renderDefaultEl.root = renderDefaultElRoot;
      renderDefaultElRoot.render(<ModalContainer dlgType={"Ошибка"} content={Message} />);
    }

    tokenProcessing(data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  React.useEffect(() => {
    tokenProcessing(props.Json);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  async function ChangeProgress(RequestID: any, result: string) {
    const params = new Map(),
      data = { Result: result || "" };
    params.set("prefix", "project");
    params.set("comand", "ResumeRequest");
    params.set("RequestID", RequestID);
    params.set("WSM", "1");
    const resp = await AxiosRequest(true, params, data);
    setData(resp);
  }

  const Close = () => {
    const footerProgressElRoot: Root = document.getElementById("footerProgress")!.root;
    footerProgressElRoot.render(<></>);
    // SetLoadingCursor(true);
  };

  const normalise = (value: any, MAX: any) => ((Number(value) - 0) * 100) / (Number(MAX) - 0);

  function tokenProcessing(json: any) {
    ///project~ResumeRequest?LicGUID=D100CAB54337ED32E087B59F6CE41511&RequestID=18892&WSM=1 HTTP/1.1
    const footerProgressElRoot: Root = document.getElementById("footerProgress")!.root;
    if (json.Break !== undefined) {
      let Token, RequestID: any;

      Token = json.Token;
      RequestID = json.Params.RequestID;
      if (Token === "ChangeStatusProgress") {
        let Count, Stop, Title, Index;
        Count = json.Params.Count;
        Stop = json.Params.Stop;
        Title = json.Params.Title;
        Index = json.Params.Index;
        if (isNaN(Index)) Index = 0;
        if (Title !== undefined) setTitle(Title);
        if (Stop !== undefined) setStop(true);
        if (ReqId === "") setReqId(RequestID);
        setProgress(normalise(Index, Count));
        ChangeProgress(RequestID);
      } else if (Token === "ShellExecute") {
        footerProgressElRoot.render(<></>);
        // SetLoadingCursor(true);
        tokenProcessingTest(json, props.subData);
      } else if (Token === "SetProgressLabel") {
        footerProgressElRoot.render(<></>);
        // SetLoadingCursor(true);
        if (props.setReturnValue !== undefined && props.from === "ModalProgress") {
          props.setReturnValue(json);
        } else {
          tokenProcessingTest(json);
        }
      } else {
        // if(props.from === "ModalProgress" && props.setReturnValue !== undefined){
        // props.setReturnValue(json);
        // }else{
        footerProgressElRoot.render(<></>);
        tokenProcessingTest(json, props.subData);
        // }
      }
    } else if (isNaN(Progress)) {
      //todo при отсутствии каунта скрывать всё
      footerProgressElRoot.render(<></>);
      if (props.setReturnValue !== undefined) {
        //
        if (props.from !== "Forms") {
          footerProgressElRoot.render(<></>);
          props.setReturnValue(json);
        } else if (props.from === "Forms" && json.Form !== undefined) props.setReturnValue(json);
      }
      ClearAllLoadMask();
    } else {
    }
  }

  return (
    <GridLegacy>
      <GridLegacy
        container
        sx={{ pl: 2 }}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        style={{
          width: "fit-content",
          height: "33px",
          // position: "absolute",
          // bottom: "1.7%",
          // left: "0%",
        }}
        spacing={1}
      >
        <GridLegacy item>
          <LinearProgress variant="determinate" value={Progress} style={{ height: "10px", width: "100px" }} />
        </GridLegacy>
        <GridLegacy item style={{ color: "black" }}>
          {Title}
        </GridLegacy>
      </GridLegacy>
      <GridLegacy
        style={{
          width: "150px",
          height: "20px",
          // position: "absolute",
          // bottom: "1.15%",
          // right: "1%",
          display: stop ? "unset" : "none",
        }}
      >
        <Button
          id={ReqId}
          variant="contained"
          style={{
            height: "inherit",
            width: "inherit",
            textTransform: "none",
          }}
          onClick={(ev: React.MouseEvent<HTMLButtonElement>) => {
            ChangeProgress(ev.target.id, "1");
            Close();
          }}
        >
          Прервать
        </Button>
      </GridLegacy>
    </GridLegacy>
  );
};

export default ChangeStatusProgressFooter;
